"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseClient = void 0;
const decentraland_crypto_fetch_1 = __importDefault(require("decentraland-crypto-fetch"));
const nodeURL = __importStar(require("url"));
const ClientError_1 = require("./ClientError");
const DEFAULT_RETRIES = 3;
const DEFAULT_RETRY_DELAY = 1000;
const DEFAULT_NON_RETRYABLE_STATUSES = [400, 401, 403, 404, 409, 422];
const URL = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.URL) !== null && _a !== void 0 ? _a : nodeURL.URL;
class BaseClient {
    constructor(url, config) {
        var _a, _b, _c;
        this.sleep = (delay) => new Promise(resolve => {
            setTimeout(resolve, delay);
        });
        this.getIdentity = () => this.identity instanceof Function ? this.identity() : this.identity;
        this.rawFetch = (path, init) => {
            var _a;
            const fullUrl = new URL(path, this.baseUrl);
            const identity = (_a = init === null || init === void 0 ? void 0 : init.identity) !== null && _a !== void 0 ? _a : this.getIdentity();
            return (0, decentraland_crypto_fetch_1.default)(fullUrl.toString(), Object.assign(Object.assign({}, init), { identity }));
        };
        this.fetch = (path, init) => __awaiter(this, void 0, void 0, function* () {
            var _d;
            for (let attempt = 0; attempt <= this.retries; attempt++) {
                try {
                    let response;
                    let parsedResponse;
                    try {
                        response = yield this.rawFetch(path, init);
                        parsedResponse = yield response.json();
                    }
                    catch (error) {
                        throw new ClientError_1.ClientError(error.message, undefined, null);
                    }
                    if (!response.ok || parsedResponse.ok === false) {
                        const errorMessage = (_d = parsedResponse.message) !== null && _d !== void 0 ? _d : parsedResponse.error;
                        throw new ClientError_1.ClientError(errorMessage !== null && errorMessage !== void 0 ? errorMessage : `Request failed with status code ${response.status}`, response.status, parsedResponse.data);
                    }
                    if (parsedResponse.ok === true) {
                        return parsedResponse.data;
                    }
                    else {
                        return parsedResponse;
                    }
                }
                catch (error) {
                    console.error(`[API] HTTP request failed: ${error.message || ''}`, error);
                    if (this.retries === attempt || (error.status && this.nonRetryableStatuses.includes(error.status)))
                        throw error;
                    yield this.sleep(this.retryDelay);
                }
            }
            throw new Error('Unreachable code');
        });
        this.baseUrl = url;
        this.identity = config === null || config === void 0 ? void 0 : config.identity;
        this.retries = (_a = config === null || config === void 0 ? void 0 : config.retries) !== null && _a !== void 0 ? _a : DEFAULT_RETRIES;
        this.retryDelay = (_b = config === null || config === void 0 ? void 0 : config.retryDelay) !== null && _b !== void 0 ? _b : DEFAULT_RETRY_DELAY;
        this.nonRetryableStatuses = (_c = config === null || config === void 0 ? void 0 : config.nonRetryableStatuses) !== null && _c !== void 0 ? _c : DEFAULT_NON_RETRYABLE_STATUSES;
    }
}
exports.BaseClient = BaseClient;
//# sourceMappingURL=BaseClient.js.map